/**
 * Settings that belong to *a book* (its layout), not the reader. Everything else
 * (typography, behaviour, keybinds, filters) is a global preference.
 * Spec: docs/image-engine-spec.md §11.3.
 */
const PER_BOOK_KEYS = {
    image: [
        'layout',
        'direction',
        'spreadOffset',
        'pageGap',
        'fit',
        'stretchSmallPages',
        'maxWidth',
        'maxHeight',
    ],
    text: ['columns'],
};
const GLOBAL_KEY = 'pore:settings:global';
const bookKey = (id) => `pore:settings:book:${id}`;
function safeStorage() {
    try {
        const s = globalThis.localStorage;
        if (!s)
            return null;
        const probe = '__pore_probe__';
        s.setItem(probe, '1');
        s.removeItem(probe);
        return s;
    }
    catch {
        return null;
    }
}
function read(storage, key) {
    try {
        const raw = storage.getItem(key);
        return raw ? JSON.parse(raw) : {};
    }
    catch {
        return {};
    }
}
function pick(obj, keys) {
    const out = {};
    for (const k of keys)
        if (k in obj)
            out[k] = obj[k];
    return out;
}
/** localStorage-backed persistence: global prefs + a per-book layout layer. */
export function createSettingsPersistence(storage = safeStorage()) {
    if (!storage) {
        return { initial: () => ({}), save: () => { } };
    }
    return {
        initial(bookId, kind) {
            const perBook = PER_BOOK_KEYS[kind];
            return {
                ...read(storage, GLOBAL_KEY),
                ...pick(read(storage, bookKey(bookId)), perBook),
            };
        },
        save(bookId, kind, settings) {
            const s = settings;
            const perBook = PER_BOOK_KEYS[kind];
            const global = {};
            const book = {};
            for (const [k, v] of Object.entries(s)) {
                (perBook.includes(k) ? book : global)[k] = v;
            }
            try {
                storage.setItem(GLOBAL_KEY, JSON.stringify(global));
                storage.setItem(bookKey(bookId), JSON.stringify(book));
            }
            catch {
                /* quota / private mode — ignore */
            }
        },
    };
}
//# sourceMappingURL=settings-store.js.map